/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_Total_EarnedInputs */

const en_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Earned`)
};

const es_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total ganado`)
};

const fr_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total gagné`)
};

const de_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt verdient`)
};

const ja_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`総獲得額`)
};

const zh_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总计赚取`)
};

const ar_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجمالي الأرباح`)
};

const id_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Diperoleh`)
};

const it_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale Guadagnato`)
};

const ru_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего заработано`)
};

const pt_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Ganho`)
};

const ko_affiliate_total_earned = /** @type {(inputs: Affiliate_Total_EarnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`총 수익`)
};

/**
* | output |
* | --- |
* | "Total Earned" |
*
* @param {Affiliate_Total_EarnedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_total_earned = /** @type {((inputs?: Affiliate_Total_EarnedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_Total_EarnedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_total_earned(inputs)
	if (locale === "es") return es_affiliate_total_earned(inputs)
	if (locale === "fr") return fr_affiliate_total_earned(inputs)
	if (locale === "de") return de_affiliate_total_earned(inputs)
	if (locale === "ja") return ja_affiliate_total_earned(inputs)
	if (locale === "zh") return zh_affiliate_total_earned(inputs)
	if (locale === "ar") return ar_affiliate_total_earned(inputs)
	if (locale === "id") return id_affiliate_total_earned(inputs)
	if (locale === "it") return it_affiliate_total_earned(inputs)
	if (locale === "ru") return ru_affiliate_total_earned(inputs)
	if (locale === "pt") return pt_affiliate_total_earned(inputs)
	return ko_affiliate_total_earned(inputs)
});